import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=2498c584"
import script from "./ChatThread.vue?vue&type=script&lang=ts"
export * from "./ChatThread.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports